module.exports = __webpack_public_path__ + "static/media/center_03.2b1c0e6d.jpg";